import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import history from 'dashboard/history';
import moment from 'moment';
import { numeral } from 'lib/helpers';
import CDNManager from 'dashboard/CDN/CDNManager';
import Toolbar from '../Toolbar.react';
import Button from 'components/Button/Button.react';
import stylesButton from 'components/Button/Button.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import BrowserMenu from 'components/BrowserMenu/BrowserMenu.react';
import MenuItem from 'components/BrowserMenu/MenuItem.react';
import Separator from 'components/BrowserMenu/Separator.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';

import styles from '../CDN.scss'
import settingsStyles from 'dashboard/Settings/Settings.scss';
import serviceActivate from './ServiceActivate.scss';

export default class ServiceActivate extends Component {
  constructor(props) {
    super();

    this.section = 'CDN';
    this.subsection = 'Service Enable';

    this.state = {
      loading: true,
    };
  }

  componentWillReceiveProps(nextProps) {

  }

  componentDidMount() {
    this.setState({
      loading: false,
      selected: 2,
    });
  }

  selectHandler(v) {
    this.setState({
      selected: v,
    })
  }

  activate() {
    // console.log('activate', this.state.selected);
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    if(this.state.loading) {
      return (
        <div className={classes.join(' ')}>
          <Toolbar {...this.props} subsection={this.props.route.name} />
          <PreLoader loading={this.state.loading} />
        </div>
      );
    }

    return (
      <div className={classes.join(' ')}>
        {
          <Toolbar {...this.props} hideMenus={true} subsection={this.props.route.name} />
        }
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={styles.holder}>
              <h2 className={styles.title}>Choose your plan</h2>

              <div className={serviceActivate.box}>
                <div className={serviceActivate.itemWrapper}>
                  <div className={[serviceActivate.item, this.state.selected === 1 ? serviceActivate.selected : null].join(' ')} onClick={() => this.selectHandler(1)}>
                    <div>
                      <h2>Plan 1</h2>
                      <ul className={serviceActivate.features}>
                        <li>feature 1</li>
                        <li>feature 2</li>
                        <li>feature 3</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={serviceActivate.itemWrapper}>
                  <div className={[serviceActivate.item, this.state.selected === 2 ? serviceActivate.selected : null].join(' ')} onClick={() => this.selectHandler(2)}>
                    <span>Recommended</span>
                    <div>
                      <h2>Plan 2</h2>
                      <ul className={serviceActivate.features}>
                        <li>feature 1</li>
                        <li>feature 2</li>
                        <li>feature 3</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={serviceActivate.itemWrapper}>
                  <div className={[serviceActivate.item, this.state.selected === 3 ? serviceActivate.selected : null].join(' ')} onClick={() => this.selectHandler(3)}>
                    <div>
                      <h2>Plan 3</h2>
                      <ul className={serviceActivate.features}>
                        <li>feature 1</li>
                        <li>feature 2</li>
                        <li>feature 3</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.action}>
                <Button value='Go' color='green' onClick={() => this.activate()} />
              </div>
            </div>
          </div>
        </PreLoader>
      </div>
    );
  }
}
